/** Configuracion de build (variables VITE_*). Todo lo que hay aqui es publico en el bundle. */
export const config = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/+$/, ""),
  apiKey: import.meta.env.VITE_API_KEY ?? "",
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? "",
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? "",
} as const;

/** La sincronizacion en la nube solo se activa con Supabase configurado. */
export const cloudSyncEnabled = Boolean(config.supabaseUrl && config.supabaseAnonKey);
